import { useLoginStateProvider } from "./LoginStateProvider";
import { useMemo } from "react";
import { AbTestNames, AbTestResult } from "./core/api/AbTests/model";

type TestsMap = Record<AbTestNames, AbTestResult>;
type UserAbTests = { status: "loading" | "not-found" } | { status: "found"; tests: TestsMap };

function useUserAbTests(testNames: AbTestNames | AbTestNames[]): UserAbTests {
  const { userAbTests, analyticsStatus } = useLoginStateProvider();
  return useMemo(() => {
    if (!userAbTests) {
      // ignore ab tests until we know tracking is loaded
      return analyticsStatus !== false ? { status: "loading" } : { status: "not-found" };
    }
    const multipleTests = Array.isArray(testNames);
    const wantedTests = userAbTests.results.filter((x) =>
      multipleTests ? testNames.includes(x.testName as AbTestNames) : x.testName === testNames
    );

    if (wantedTests.length > 0) {
      return {
        status: "found",
        tests: wantedTests.reduce(
          (previousValue, currentValue) => ({ ...previousValue, [currentValue.testName]: currentValue }),
          {} as TestsMap
        ),
      };
    }
    return { status: "not-found" };
  }, [userAbTests, analyticsStatus, testNames]);
}

export default useUserAbTests;
